<div class="bmc-user-jobs-description">
  <div class="bmc-user-jobs-description__header">
    <h4 class="bmc-user-jobs-description__title bz-font-weight--semibold">{{'USERJOBS.DESCRIPTION_TITLE' | translate}}</h4>
  </div>
  <div *ngIf="!job" class="bmc-user-jobs-description__no-selection">
    <h3>{{'USERJOBS.NO_JOB_SELECTED' | translate}}</h3>
  </div>
  <div class="bmc-user-jobs-description__tabs" *ngIf="job">
    <bzg-tab-set (onSelectTab)="selectedTab = $event.index">
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'USERJOBS.SETTINGS' | translate | uppercase}}">
        <job-settings class="bmc-user-jobs-description__tabs__component-container" [jobType]="jobType" [currentJob]="job"
                      (saveJob)="saveUserJob($event)" (cancel)="validatePendingChanges()" (reset)="reset()"></job-settings>
      </bzg-tab-item>
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'USERJOBS.JOB_STEPS' | translate | uppercase}}">
        <job-steps class="bmc-user-jobs-description__tabs__component-container-scroll" [currentJob]="job" [jobType]="jobType"></job-steps>
      </bzg-tab-item>
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 2}" displayName="{{'USERJOBS.JOB_SCHEDULES' | translate | uppercase}}">
        <job-schedules class="bmc-user-jobs-description__tabs__component-container-scroll" [currentJob]="job" [jobType]="jobType"></job-schedules>
      </bzg-tab-item>
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 3}" displayName="{{'USERJOBS.JOB_EXECUTION' | translate | uppercase}}">
        <job-execution class="bmc-user-jobs-description__tabs__component-container" [jobType]="jobType" [userJobGuid]="job.guid"></job-execution>
      </bzg-tab-item>
    </bzg-tab-set>
  </div>
</div>
